import { render } from "./Switch.vue?vue&type=template&id=3576c20c&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=3576c20c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3576c20c"]])

export default __exports__